import { paramsSerializerRepeat } from '../utils/url'
import { ItineraryRouteType } from '../../types/itinerary.route'

export const buildGpsWaypointsParameter = (gpsInfo: ItineraryRouteType['gps']) => {
  return (gpsInfo?.query_path?.waypoints ?? [])
    .map((waypoint) => {
      const [lng, lat] = waypoint.split(',')
      return `${lat},${lng}`
    })
    .join(';')
}

export const extractGpsQueryParameters = (gpsInfo: ItineraryRouteType['gps']) =>
  (gpsInfo?.query_params ?? []).reduce(
    (acc, curr) => ({
      ...acc,
      [curr.field]: curr.value,
    }),
    {}
  )

export const buildGpsQueryParameters = (gpsInfo: ItineraryRouteType['gps']) => {
  return paramsSerializerRepeat(extractGpsQueryParameters(gpsInfo))
}

const buildGpsLink = (provider: string, waypoints: string, params: string) =>
  `mappy://fr.mappy.com/gps/${provider}/${waypoints}?${params}`

export const getGpsLink = (gpsInfo: ItineraryRouteType['gps']) => {
  const provider = gpsInfo?.query_path?.gps_provider
  const waypoints = buildGpsWaypointsParameter(gpsInfo)

  if (!provider || !waypoints) return null

  const params = buildGpsQueryParameters(gpsInfo)

  return buildGpsLink(provider, waypoints, params)
}
